module.exports = __webpack_public_path__ + "static/bmw-5cef6552cc7a0383c93bdd5c7be2a7ac.png";